// src/components/CalidadesSection.js
import React from "react";
import "./CalidadesSection.css";
import img4 from "../assets/img4.jpg";

const CalidadesSection = () => {
  const items = [
    "Cimentación y estructura",
    "Cerramientos de fachada",
    "Carpintería exterior",
    "Tabiquerías y aislamiento interior",
    "Revestimientos interiores y pinturas",
    "Carpintería interior",
    "Fontanería y aparatos sanitarios",
    "Electricidad",
    "Agua caliente",
    "Telecomunicaciones",
    "Aire acondicionado",
    "Mobiliario de cocina",
    "Zonas comunes",
  ];

  return (
    <section className="calidades-section">
      {/* Title Section */}
      <div className="calidades-title-container">
        <h2 className="calidades-title">Memoria de Calidades</h2>
      </div>

      <div className="calidades-divider"></div>

      {/* Content Section */}
      <div className="calidades-content">
        <div className="calidades-left">
          <ul className="calidades-list">
            {items.map((item, index) => (
              <li key={index} className="calidades-item">
                {item}
              </li>
            ))}
          </ul>
        </div>

        <div className="calidades-right">
          <img
            src={img4}
            alt="Memoria de calidades"
            className="calidades-image"
          />
        </div>
      </div>
    </section>
  );
};

export default CalidadesSection;
